export default __webpack_public_path__ + "static/media/checklist-outline-16px.141819dd.svg";